<template>
   <div class="main_help bg-dark">
     <div class="main-content">
   <!-- Print / save the guide as a PDF, keeping the portal styling. Super Admin only. -->
   <div class="print-bar no-print" v-if="userType == 'Super Admin'">
     <button type="button" class="print-btn" @click="printHelp">
       <i class="fa fa-print"></i> Print / Save as PDF
     </button>
   </div>
   <br>
   <!-- ABBREVIATIONS -->
    <div class="card" style="width: 69.5rem;">
      <div class="card-body">
        <h5 class="card-title">Abbreviations</h5>
        <h6 class="card-subtitle mb-2 text-muted">The following abbreviations are used in the document.</h6>
          <p class="card-text">M4A - Manhole 4 Africa</p>
          <p class="card-text">IOT - Internet Of Things</p>
          <p class="card-text">RAMAC - Remote Access management and Control Systems</p>
          <p class="card-text">DB - Database</p>
          <p class="card-text">TBC - To Be Continued </p>
          <p class="card-text">EG - Example given</p>
      </div>
    </div>
   <br>
   <!-- SYSTEM OVERVIEW-->
    <div class="card" style="width: 69.5rem;">
      <div class="card-body">
        <h5 class="card-title">System overview</h5>
        <h6 class="card-subtitle mb-2 text-muted">The m4a production consist of the following components.</h6>
          <p class="card-text">1. WiFi – WiFi is used by the IOT devices installed on the machine to communicate with server.</p>
          <p class="card-text">2. RAMAC BLEW – RAMAC BLEW are devices installed on the machine to monitor production.</p>
          <p class="card-text">3. RAMAC - Remote Access management and Control Systems</p>
          <p class="card-text">4. Backend - Back End is for processing the data sent from the devices and store it in the DB.</p>
          <p class="card-text">5. MYSQL DB – MySQL DB is used to store processed data and raw data </p>
          <p class="card-text">6. Front End – Front End is the web portal which is described in this document.</p>
          <img class="systemoverview" src="../assets/img/systemoverview.png" alt="systemoverview">
          <h4>System Overview</h4>
      </div>
    </div>
   <br>
   <!-- FACTORY STATE -->
    <div class="card" style="width: 69.5rem;">
      <div class="card-body">
        <h5 class="card-title">Factory State</h5>
        <h6 class="card-subtitle mb-2 text-muted">The Factory State selector in the sidebar sets the operating state for the whole plant. It controls whether downtime alerts are sent.</h6>
          <p class="card-text">1.	RUNNING – Normal production. Downtime alerts are active: if a machine that should be running stops sending data, subscribers are notified.</p>
          <p class="card-text">2.	POWER CUT – Use during a power outage. Downtime alerts are paused so you are not notified about machines that are down for a known reason.</p>
          <p class="card-text">3.	WEEKEND – Use during planned non-production periods. Downtime alerts are paused.</p>
          <p class="card-text">Tip: Always set the Factory State to POWER CUT or WEEKEND during planned downtime to avoid false alerts, and back to RUNNING when production resumes.</p>
      </div>
    </div>
    <br>
   <!-- SUMMARY DASHBOARD -->
    <div class="card" style="width: 69.5rem;">
      <div class="card-body">
        <h5 class="card-title">Summary Dashboard</h5>
        <h6 class="card-subtitle mb-2 text-muted">Summary dashboard shows the summary of the current production for all the machines. When you click the eye icon for a specific machine it will navigate to the machine graph.</h6>
         <h5 class="sub-haerder">Extruders / Corrugators</h5> 
          <p class="card-text">The Extruders table it shows the summary of all the extruders. The RAMAC BLEW devices installed on all the extruder lines are configured to send data every 10 minutes as long the machine is on.</p>
          <p class="card-text">1.	Thresh – This is number of meters that the machine is suppose to produce per minute.</p>
          <p class="card-text">2.	Meters Per Minute – These are the meters the machine is producing per minute. If the meters per minute is lower that the number set as Thresh the row background will turn yellow.</p>
          <p class="card-text">3.	Sensor Status – This will change between (On and Off) if there is no data received for the past 15 minutes. </p>
         <h5 class="sub-haerder">Compression Moulds</h5> 
          <p class="card-text">The Compression moulds table shows the summary of all the compression moulds. The RAMAC BLEW devices installed on all the compression moulds are configured to send data every time when the machine opens or closing.</p>
          <p class="card-text">1.	Quantity Products – This shows the quantity of products for the current day.</p>
          <p class="card-text">2.	Sensor Status – This will change between (On and Off) if there is no state change in for more than the product manufacturing time set when adding product.</p>
         <h5 class="sub-haerder">Injection Moulds</h5> 
          <p class="card-text">The Injection moulds table shows the summary of all the compression moulds. The RAMAC BLEW devices installed on all the Injection moulds are configured to send data every time when the machine opens or closing.</p>
          <p class="card-text">1.	Quantity Products – This shows the quantity of products for the current day.</p>
          <p class="card-text">2.	Sensor Status – This will change between (On and Off) if there is no state change in for more than the product manufacturing time set when adding product.</p>

         <h5 class="sub-haerder">Summary Dashboard Config</h5> 
          <p class="card-text">The summary dashboard configuration allows you to change the machine status and the current product without navigating away from the dashboard.</p>
          <p class="card-text">1.	On the summary DB under the machine status column if you click on the machine status it gives you drop of all the machine status, select the status the machine is current on the machine will change to what you have selected.</p>
          <p class="card-text">2.	On the summary DB under the current product column if you click on the current product, it gives you a drop-down list of all the products select the current product in the machine current product will change to what you have selected.</p>
      </div>
          <img class="summarydb" src="../assets/img/summarydb.png">
          <router-link to="/" tag="h4">Summary Dashboard</router-link>
    </div>
    <br>
    <!-- REPORTS -->
    <div class="card" style="width: 69.5rem;">
      <div class="card-body">
        <h5 class="card-title">Reports</h5>
        <h6 class="card-subtitle mb-2 text-muted">The Reports page shows production totals per machine for a date range you choose.</h6>
          <p class="card-text">1.	Date Range – Choose the start and end dates to report on.</p>
          <p class="card-text">2.	Production Totals – For each machine the report shows the meters produced (Extruders / Corrugators) or the number of products made (Compression / Injection Moulds) over the selected range.</p>
          <p class="card-text">3.	Export – Download the report to Excel for record-keeping or further analysis.</p>
      </div>
    </div>
    <br>
    <!-- CONFIGURATION -->
    <div class="card" style="width: 69.5rem;">
      <div class="card-body">
        <h5 class="card-title">Configuration</h5>
        <!-- EXTRUDER -->
        <h5 class="sub-haerder">Extruder</h5> 
        <h6 class="card-subtitle mb-2 text-muted">The extruder will display the list of all the extruder machines.</h6>
         <h5 class="sub-haerder">View (Eye Icon)</h5> 
          <p class="card-text">The View button will navigate to the machine page. On the machine summary page material extruded the default filter is for the current day and the machine history the default filter is for current date and previous seven day.</p>
          <p class="card-text">1.	Material Extruded Filter – This filter gives the ability to filter the graph you want to view for a selected data time and total meters produced at the selected date range. </p>
          <p class="card-text">2.	Machine History Filter – This filter gives the ability to filter the data for a specific date range or day.</p>
          <p class="card-text">3.	Export - This gives you the ability to export a report for a selected data range.</p>
         <h5 class="sub-haerder">Machine Summary</h5> 
          <p class="card-text">The machine summary shows the summary for the selected date range on the material extruded filter default is the current date.</p>
          <p class="card-text">1.	Machine state - This will change between (Running and Stopped), if the same number of pulses is received twice the status will show stopped.</p>
          <p class="card-text">2.	Sensor Status - This will change between (On and Off) if there is no data received for the past 15 minutes the status will be Off.</p>
          <p class="card-text">3.	Total Meters – These are total meters that have been produce on the selected date range.</p>
         <h5 class="sub-haerder">Machine configuration (Gear icon)</h5> 
          <p class="card-text">The config button will navigate to configuration page on the configuration page you can add new or update the existing configurations.</p>
          <p class="card-text">1.	Pulse Per Meter – These are the pulses generated by the encoder per meter the machine produced.</p>
          <p class="card-text">2.	Comm Interval – This is the communication interval that the RAMAC device must send a message when the machine is running.</p>
          <p class="card-text">3.	Meter Per Minute – These are the meters that the machine is expected to produce per minute. Meters per mite is used as a thresh hold on the summary dashboard.</p>
          <p class="card-text">4.	Machine State – The state of the machine.</p>
         <h5 class="sub-haerder">Machine Edit (Pen Icon)</h5> 
          <p class="card-text">This button navigates to the edit page.</p>
          <p class="card-text">1.	Machine Name – The name of the machine.</p>
          <p class="card-text">2.	Position – The line number of the machine.</p>
          <p class="card-text">3.	Type – The type of the machine.</p>
          <p class="card-text">4.	Site – The site where the machine is installed.</p>

        <!-- COMPRESSION AND INJECTION CONFIGURATION -->
        <h5 class="sub-haerder">Compression and Injection Configuration</h5> 
        <h6 class="card-subtitle mb-2 text-muted">The compression will display the list of all the compression moulds and injection will display all the injection moulds.</h6>
         <h5 class="sub-haerder">View (Eye Icon)</h5> 
          <p class="card-text">The View button will navigate to the machine page. On the machine page compress monitoring the default filter is for the current day and the machine history the default filter is for current date and previous seven day.</p>
          <p class="card-text">1.	Compress Monitoring Filter - This filter gives the ability to filter the graph you want to view for a selected data time and total meters produced at the selected date range.</p>
          <p class="card-text">2.	Machine History Filter – This filter gives the ability to filter the data for a specific date range or day.</p>
          <p class="card-text">3.	Export -- This gives you the ability to export a report for a selected data range.</p>
         <h5 class="sub-haerder">Machine Summary</h5> 
          <p class="card-text">The machine summary shows the summary for the selected date range on the compress monitoring filter default is the current data.</p>
          <p class="card-text">1.	Machine state - This will change between (On and Off), if the last datetime for the last data that was received is more than manufacturing time of current product in the machine the status will show Off.</p>
          <p class="card-text">2.	Total Products – These are total products that have been produced on the selected date range.</p>

         <h5 class="sub-haerder">Machine configuration (Gear icon)</h5> 
          <p class="card-text">The config button will navigate to configuration page on the configure page you add new or update the existing configurations.</p>
          <p class="card-text">1.	Product – The product that is current in the production line.</p>
          <p class="card-text">2.	Machine State – The state of the machine.</p>

         <h5 class="sub-haerder">Machine Edit (Pen Icon)</h5> 
          <p class="card-text">This button navigates to the edit page.</p>
          <p class="card-text">1.	Machine Name – The name of the machine.</p>
          <p class="card-text">2.	Position – The line number of the machine.</p>
          <p class="card-text">3.	Type – The type of the machine.</p>
          <p class="card-text">4.	Site – The site where the machine is installed.</p>
      </div>
       <img class="summarydb" src="../assets/img/confgExtruder.png">
       <router-link tag="h4" to="/Extruder">
         Extruder Config
       </router-link>
       <br>
       <img class="summarydb" src="../assets/img/extrudergraph.png">
       <br>
       <img class="summarydb" src="../assets/img/confgCompress.png">
       <router-link tag="h4" to="/Compression">
         Compression Config
       </router-link>
       <br>
       <img class="summarydb" src="../assets/img/injectionconfig.png">
       <router-link tag="h4" to="/Injection">
         Injection Config
       </router-link>
       <br>
       <img class="summarydb" src="../assets/img/compressgraph.png">
    </div>

    <br>
    <!-- PRODUCTS -->
    <div class="card" style="width: 69.5rem;">
      <div class="card-body">
        <h5 class="card-title">Products</h5>
        <h6 class="card-subtitle mb-2 text-muted">The product page shows the list of all the existing products. On the product page you can add or update the existing products.</h6>
         <h5 class="sub-haerder">Add / Edit Product.</h5> 
          <p class="card-text">Required fields to fill in when adding or editing products.</p>
          <p class="card-text">1.	Name – Product name.</p>
          <p class="card-text">2.	Type – Type of a product. e.g. (Lid, Base, etc)</p>
          <p class="card-text">3.	MNF Time – The time the machine is going to take to complete the product.</p>
          <p class="card-text">4.	Description – Details about the Product.</p>
         <h5 class="sub-haerder">Delete Product</h5> 
      </div>
        <img class="summarydb" src="../assets/img/products.png">

        <router-link tag="h4" to="/Products">
          Products
        </router-link>
        <br>
        <img class="summarydb" src="../assets/img/addproduct.png">
    </div>
    <br>

    <!-- MACHINE STATUS-->
        <div class="card" style="width: 69.5rem;">
      <div class="card-body">
        <h5 class="card-title">Machine Status</h5>
        <h6 class="card-subtitle mb-2 text-muted">The machine status shows the list off all machine status and allows you to add new machine status.</h6>
         <h5 class="sub-haerder">Add Machine Status.</h5> 
          <p class="card-text">Required fields to fill in when adding or editing machine status.</p>
          <p class="card-text">1.	Name – Name that will be displayed on the summury DB.</p>
          <p class="card-text">2.	Description – This is the full discription about the machine status that you are adding.</p>
      </div>
        <img class="summarydb" src="../assets/img/machinestatus.png">

        <router-link tag="h4" to="/MachineStatus">
            Machine Status
          </router-link>
          <br>
      </div>
      <br>
    <!-- NOTIFICATIONS AND ALERTS -->
    <div class="card" style="width: 69.5rem;">
      <div class="card-body">
        <h5 class="card-title">Notifications &amp; Alerts</h5>
        <h6 class="card-subtitle mb-2 text-muted">The system automatically alerts subscribers by Telegram and email when a machine that should be running stops sending data (downtime).</h6>
         <h5 class="sub-haerder">When alerts are sent</h5>
          <p class="card-text">1.	A machine is flagged as down when it is set to RUNNING but has not sent data for longer than its expected communication interval, while the Factory State is RUNNING.</p>
          <p class="card-text">2.	If a machine stays down you are reminded roughly every 4 hours, so you are kept informed without being spammed.</p>
          <p class="card-text">3.	Alerts are paused when the Factory State is POWER CUT or WEEKEND.</p>
         <h5 class="sub-haerder">Subscribing to alerts</h5>
          <p class="card-text">On the Users page each user has an Email and a Telegram notification toggle (the bell icons). Turn a channel on to receive alerts on it.</p>
         <h5 class="sub-haerder">Setting up Telegram</h5>
          <p class="card-text">1.	Open Telegram and start a chat with the M4A portal bot (search for it and press Start). This lets the system learn your Telegram chat so it can message you.</p>
          <p class="card-text">2.	Make sure your Telegram username is saved on your user profile (Users page).</p>
          <p class="card-text">3.	Use the Telegram &quot;Send Test Message&quot; button next to your user on the Users page to confirm it works.</p>
         <h5 class="sub-haerder">Setting up Email</h5>
          <p class="card-text">Make sure a valid email address is on your user profile, then use the Email &quot;Send Test Message&quot; button on the Users page to confirm delivery. Check your spam folder the first time.</p>
         <h5 class="sub-haerder">Responding to a Telegram alert</h5>
          <p class="card-text">A downtime alert in Telegram includes buttons to set the machine state. Tap &quot;Off&quot; if the machine is intentionally off, or &quot;RUNNING&quot; if it is producing — the machine state on the dashboard updates directly from your reply.</p>
      </div>
    </div>
    <br>
    <!-- DEVICES -->
    <div class="card" style="width: 69.5rem;">
      <div class="card-body">
        <h5 class="card-title">Devices</h5>
        <h6 class="card-subtitle mb-2 text-muted">The Devices page lists all the RAMAC BLEW devices installed on the machines and their latest status.</h6>
          <p class="card-text">1.	Device details – Shows each device's firmware and hardware version, WiFi signal / network, and when its last message was received.</p>
          <p class="card-text">2.	Message history – Click a device to view its recent raw messages, useful for troubleshooting a device that is not reporting.</p>
      </div>
    </div>
    <br>
    <!-- USERS -->
    <div class="card" style="width: 69.5rem;">
      <div class="card-body">
        <h5 class="card-title">Users</h5>
        <h6 class="card-subtitle mb-2 text-muted">The user section will show the list of all the user that can long into the system. On this section user will have the ability to add / delete and view user details.</h6>
         <h5 class="sub-haerder">User Types</h5> 
          <p class="card-text">User type will have different access.</p>
          <p class="card-text">1.	Super Admin – Developers.</p>
          <p class="card-text">2.	Admin – Full access to the portal: dashboards, machine configuration, products, machine status and users.</p>
          <p class="card-text">3.	Manager – Can view the dashboards and change a machine's state and current product, but cannot manage users or machine configuration.</p>
          <p class="card-text">4.	View – Read-only access. Can view the dashboards and reports but cannot make changes.</p>
         <h5 class="sub-haerder">Add / Edit User</h5>
         <h6 class="card-subtitle mb-2 text-muted">Required fields when adding or editing a user.</h6>
         <p class="card-text">User type will have different access.</p>
         <p class="card-text">1.	Name – Username’s full name.</p>
         <p class="card-text">2.	Email – Valid email address.</p>
         <p class="card-text">3.	User Type – The access level: Admin, Manager or View.</p>
         <p class="card-text">4.	Phone – Cell / Work phone number.</p>
         <p class="card-text">5.	Telegram – Telegram username.</p>
         <p class="card-text">6.	Password – Default user password.</p>
      </div>
      <img class="summarydb" src="../assets/img/users.png">
      <router-link tag="h4" to="/Users">
        Users
      </router-link>
    </div>
    <br>
    <!-- LOGIN AND ACCOUNT -->
    <div class="card" style="width: 69.5rem;">
      <div class="card-body">
        <h5 class="card-title">Login &amp; Account</h5>
        <h6 class="card-subtitle mb-2 text-muted">How signing in and your session work.</h6>
          <p class="card-text">1.	Signing in – Enter your email and password on the login page. Use the eye icon to show or hide your password.</p>
          <p class="card-text">2.	Session length – For security you are automatically signed out after 9 hours. Simply log in again to continue.</p>
          <p class="card-text">3.	Too many attempts – After several failed login attempts, sign-in is briefly blocked to protect your account. Wait a minute and try again.</p>
          <p class="card-text">4.	Forgot password – Password reset is handled by an administrator. Contact a Super Admin or Admin to have your password reset on the Users page.</p>
      </div>
    </div>
    <br>
   </div>
   </div>
</template>

<script>
export default {
   data() {
      return {
         userType: ''
      }
   },
   created() {
      this.userType = localStorage.getItem('userType')
   },
   methods: {
      // Print just the guide. The body class scopes the print rules to this
      // action so printing any other page is unaffected.
      printHelp() {
         document.body.classList.add('print-help')
         const cleanup = () => {
            document.body.classList.remove('print-help')
            window.removeEventListener('afterprint', cleanup)
         }
         window.addEventListener('afterprint', cleanup)
         // Safari/older browsers don't always fire afterprint.
         setTimeout(cleanup, 60000)
         window.print()
      }
   }
}
</script>

<style scoped>
.main_help {
  max-height: 90vh;
  width: 100%;
  overflow-y: auto;
  background: var(--bg-base);
}

.main-content {
  margin-left: 19%;
  max-width: 1080px;
  padding: 24px 28px 48px 10px;
}

/* Print / Save as PDF control */
.print-bar {
  display: flex;
  justify-content: flex-end;
  padding: 18px 26px 0 26px;
}

.print-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--accent);
  color: var(--accent-contrast);
  border: none;
  border-radius: var(--radius);
  padding: 9px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: var(--shadow);
}

.print-btn:hover {
  background: var(--accent-hover);
}

.print-btn i {
  margin-right: 2px;
}

/* Each section is an elevated surface panel with a clear border */
.card {
  width: auto !important;
  max-width: 100%;
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius-lg) !important;
  box-shadow: var(--shadow);
  margin-bottom: 22px;
  overflow: hidden;
}

.card-body {
  padding: 22px 26px;
}

/* Section heading — the most prominent element in each card */
.card-title {
  text-align: left;
  font-size: 21px;
  font-weight: 800 !important;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: var(--text) !important;
  margin: 0 0 12px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid var(--accent);
}

/* Intro line under a heading — lighter and lighter-weight than the heading */
.card-subtitle {
  text-align: left;
  margin: 0 0 14px 0 !important;
  font-size: 15px;
  font-weight: 400 !important;
  color: var(--text-muted) !important;
  line-height: 1.55;
}

/* Body copy — clearly readable */
.card-text {
  text-align: left;
  margin: 0 0 8px 24px;
  padding: 0;
  font-size: 14.5px;
  font-weight: 400;
  color: var(--text) !important;
  line-height: 1.6;
}

/* Sub-section header inside a card */
.sub-haerder {
  text-align: left;
  margin: 18px 0 8px 2px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--accent);
}

/* Screenshots */
img {
  display: block;
  margin: 14px 26px;
  border-radius: var(--radius);
  max-width: calc(100% - 52px);
  height: auto;
  border: 1px solid var(--border);
}

.systemoverview {
  width: 85%;
  max-width: calc(100% - 52px);
  height: auto;
  margin: 14px 26px;
  border-radius: var(--radius);
}

/* Clickable figure caption / link under a screenshot */
h4 {
  display: block;
  clear: both;
  font-style: normal;
  font-size: 15px;
  font-weight: 600;
  color: var(--accent);
  cursor: pointer;
  margin: 4px 0 14px 26px;
}

h4:hover {
  color: var(--accent-hover);
  text-decoration: underline;
}
</style>

<!-- Print rules are NOT scoped: they have to reach the sidebar, which is rendered
     by NavNew.vue. They only apply while body.print-help is set by printHelp(),
     so printing any other page behaves exactly as before. -->
<style>
@media print {
  @page {
    size: A4 portrait;
    margin: 12mm;
  }

  /* Print on white: drop every dark surface and flip the light-on-dark screen
     text to dark-on-white, otherwise the text would be invisible on paper.
     The layout, structure and screenshots are unchanged. */
  body.print-help,
  body.print-help #app,
  body.print-help .wrapper,
  body.print-help .wrapper .main_content,
  body.print-help .wrapper .main_content .info,
  body.print-help .main_help,
  body.print-help .main-content,
  body.print-help .card,
  body.print-help .card-body {
    background: #fff !important;
    background-color: #fff !important;
    background-image: none !important;
    box-shadow: none !important;
  }

  body.print-help .card,
  body.print-help .card-text,
  body.print-help .card-title,
  body.print-help .card-subtitle,
  body.print-help .sub-haerder,
  body.print-help h4,
  body.print-help h5,
  body.print-help h6,
  body.print-help p {
    color: #000 !important;
  }

  /* Muted intro lines stay a shade lighter, but dark enough to read on paper. */
  body.print-help .card-subtitle {
    color: #444 !important;
  }

  /* No card box on paper. A bordered card that flows across a page break leaves
     an orphan line at the foot of one page and the head of the next, so the
     sections run as plain text and the heading rule alone separates them. */
  body.print-help .card {
    border: none !important;
    border-radius: 0 !important;
    overflow: visible !important;
  }

  body.print-help .card-body {
    padding: 0 !important;
  }

  body.print-help .card-title {
    border-bottom: 2px solid #333 !important;
  }

  body.print-help img {
    border: 1px solid #ccc !important;
  }

  /* Hide the app chrome: sidebar, the header bar (Factory State + title),
     the snackbar, and the print button itself. */
  body.print-help .sidebar,
  body.print-help .wrapper .main_content .header,
  body.print-help #snackbar_home,
  body.print-help .no-print {
    display: none !important;
  }

  /* The sidebar is fixed at 220px and .main_content is pushed over to clear it.
     With the sidebar gone, reclaim the full page width. */
  body.print-help .wrapper .main_content {
    margin-left: 0 !important;
    width: 100% !important;
    min-height: 0 !important;
  }

  body.print-help .wrapper .main_content .info {
    margin: 0 !important;
  }

  /* The guide scrolls inside a 90vh box on screen; release it so every page prints. */
  body.print-help .main_help {
    max-height: none !important;
    height: auto !important;
    overflow: visible !important;
  }

  /* help.vue's own inner column is indented 19% for the sidebar — reset that too. */
  body.print-help .main-content {
    margin-left: 0 !important;
    max-width: 100% !important;
    padding: 0 !important;
  }

  /* Let long sections flow across pages rather than each card being bumped whole
     to the next page, which left most of every sheet blank. Headings still stay
     attached to the text beneath them. */
  body.print-help .card {
    break-inside: auto;
    page-break-inside: auto;
    box-shadow: none !important;
    /* With the box gone, whitespace is what separates one section from the next. */
    margin-bottom: 22px;
  }

  body.print-help .card-title,
  body.print-help .card-subtitle,
  body.print-help .sub-haerder {
    break-after: avoid;
    page-break-after: avoid;
  }

  /* Never split a screenshot across two pages. */
  body.print-help img {
    break-inside: avoid;
    page-break-inside: avoid;
    max-width: calc(100% - 52px) !important;
  }

  /* Screen-only spacers that waste paper. */
  body.print-help .main-content > br {
    display: none !important;
  }
}
</style>